import { inject, Provider, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import { MDS_LAYOUT_NAVIGATION_ITEMS, NavigationItem } from '@mds/ngx-layout';
import { map } from 'rxjs';
import { getTranslationValue } from '../utils/route-data.utils';

export function provideNavigationItems(): Provider {
  return {
    provide: MDS_LAYOUT_NAVIGATION_ITEMS,
    useFactory: (): Signal<NavigationItem[]> => {
      const translocoService = inject(TranslocoService);
      const initialValue: NavigationItem[] = [];

      return toSignal<NavigationItem[], NavigationItem[]>(
        translocoService.selectTranslation().pipe(
          map((translation) => [
            {
              icon: 'home',
              label: getTranslationValue(translation, 'Dev.Navigation.Home.Title'),
              link: '/home',
              routerLinkActiveOptions: { exact: true },
            },
            {
              icon: 'apps',
              label: getTranslationValue(translation, 'Dev.Navigation.Api.Title'),
              link: '/api',
            },
            {
              icon: 'shield',
              label: getTranslationValue(translation, 'Dev.Navigation.Authentication.Title'),
              link: '/authentication',
            },
          ]),
        ),
        { initialValue },
      );
    },
  };
}
